module.exports = __webpack_public_path__ + "static/media/logo192-apicafe.7f99b3b5.png";